export const hasOpenRequest = (event: any): boolean =>
    !!(event?.openRequest || event?.meta?.openRequest);

export const getOpenRequestSource = (event: any): string | undefined =>
    (event?.openRequest ?? event?.meta?.openRequest)?.source;

const openRequestMessages: Record<string, string> = {
    "qualification-change": "open-shift-request-qualification-change",
    absence: "open-shift-request-absence",
};

export const getOpenRequestMessage = (event: any): string =>
    openRequestMessages[getOpenRequestSource(event) ?? ""] ?? "has-open-shift-request";
